import {Legend, Font} from '@pepsico-ds/ui';
import PropTypes from 'prop-types';
import {memo} from 'react';

const TIER_HEIGHT = '40px';

const Tier = memo(({color, size, quantityLabel}) => {
  return (
    <section
      className='flex items-center justify-center'
      style={{height: TIER_HEIGHT, width: `${size}%`, backgroundColor: color}}>
      <Font variant='bold' size='small' textColorClass='text-white'>
        {quantityLabel}
      </Font>
    </section>
  );
});

Tier.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  quantityLabel: PropTypes.string.isRequired
};

export const TiersChart = ({
  mode,
  segments,
  title,
  leftLabel,
  rightLabel,
  legendItems,
  boundaryLabels
}) => {
  const hasSegments = segments && segments.length > 0;
  if (!hasSegments) return null;

  const isCurrencyMode = mode === 'currency';

  return (
    <div
      className={`my-4 w-full ${isCurrencyMode ? '' : 'flex flex-col items-center'}`}>
      {title && (
        <Font
          variant='bold'
          size='small'
          textColorClass='text-white'
          className='mb-4 block'>
          {title}
        </Font>
      )}
      {isCurrencyMode && (
        <div className='relative mb-2 h-4 w-full'>
          {boundaryLabels?.map((item) => (
            <Font
              key={`${item.position}-${item.text}`}
              variant='regular'
              size='small'
              textColorClass='text-white'
              className='absolute whitespace-nowrap'
              style={{
                left: `${item.position}%`,
                transform: item.transform
              }}>
              {item.text}
            </Font>
          ))}
        </div>
      )}
      <section
        className={`flex w-full overflow-hidden ${isCurrencyMode ? 'rounded-lg' : 'items-center justify-center'} ${legendItems && legendItems.length > 0 ? 'mb-5' : ''}`}>
        {leftLabel && (
          <Font
            variant='regular'
            size='small'
            textColorClass='text-white'
            className='mx-3 shrink-0'>
            {leftLabel}
          </Font>
        )}
        {segments.map((item) => (
          <Tier
            key={item.name}
            color={item.color}
            size={item.size}
            quantityLabel={item.quantityLabel}
          />
        ))}
        {rightLabel && (
          <Font
            variant='bold'
            size='small'
            textColorClass='text-white'
            className='mx-3 shrink-0'>
            {rightLabel}
          </Font>
        )}
      </section>
      {legendItems && legendItems.length > 0 && (
        <Legend
          isDark
          className='gap-6'
          direction='horizontal'
          items={legendItems}
        />
      )}
    </div>
  );
};

TiersChart.propTypes = {
  mode: PropTypes.oneOf(['store', 'currency']),
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
      quantityLabel: PropTypes.string.isRequired
    })
  ).isRequired,
  title: PropTypes.string,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  legendItems: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
      quantity: PropTypes.number
    })
  ),
  boundaryLabels: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      position: PropTypes.number.isRequired,
      transform: PropTypes.string.isRequired
    })
  )
};
